import {SentryReportCustomError} from "../utils/Sentry/Sentry";

export module CustomFunctions {

    export class controlFunctions {

        /**
         * Copy text into clipboard
         * @param str
         * @param onSuccess
         */
        public static copyToClipBoard(str: string, onSuccess?: () => void) {

            navigator.clipboard.writeText(str).then(
                () => { if (onSuccess) { onSuccess(); } })
                .catch((reason: unknown) => {
                    console.error('Impossible to copy text', reason);
                    SentryReportCustomError('Impossible to copy text');
                });
        };
    }
}
